import { readStorage, writeStorage, removeStorage } from './storage';
export const CONSENT_KEY = 'antares_consent_v2';
export const CONSENT_EVENT = 'antares:consent';
export const PREFERENCES_EVENT = 'antares:preferences';
const DURATION = 180 * 24 * 60 * 60 * 1000;
export type Consent = 'granted' | 'denied' | 'unknown';
export function getConsent(): Consent {
  if (typeof window === 'undefined') return 'unknown';
  const data = readStorage(CONSENT_KEY) as { version?: number; analytics?: string; expires?: number } | null;
  return data?.version === 2 && Number(data.expires) > Date.now() && Number(data.expires) <= Date.now() + DURATION &&
    (data.analytics === 'granted' || data.analytics === 'denied') ? data.analytics : 'unknown';
}
export function saveConsent(analytics: 'granted' | 'denied') {
  writeStorage(CONSENT_KEY, { version: 2, analytics, expires: Date.now() + DURATION });
  removeStorage('antares_cookie_consent'); // Legacy banner did not give specific analytics consent.
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: analytics }));
}
export function openPreferences() { window.dispatchEvent(new Event(PREFERENCES_EVENT)); }
export function clearOptionalStorage() {
  removeStorage('antares_attribution_v1');
  try {
    for (const key of Object.keys(localStorage)) if (/^_cl(ck|sk)$/.test(key)) localStorage.removeItem(key);
    for (const key of Object.keys(sessionStorage)) if (/^_cl(ck|sk)$/.test(key)) sessionStorage.removeItem(key);
    const host = window.location.hostname.split('.');
    const domains = ['', ...host.map((_, i) => host.slice(i).join('.'))];
    const pieces = window.location.pathname.split('/');
    const paths = ['/', ...pieces.map((_, i) => pieces.slice(0, i + 1).join('/') || '/')];
    document.cookie.split(';').forEach(cookie => {
      const name = cookie.split('=')[0].trim();
      if (!/^(_ga(?:_|$)|_gid$|_gat(?:_|$)|_gac_|_gcl_|_clck$|_clsk$)/.test(name)) return;
      for (const domain of domains) for (const path of paths) {
        document.cookie = `${name}=; Max-Age=0; path=${path}${domain ? `; domain=${domain}` : ''}; SameSite=Lax`;
      }
    });
  } catch { /* HttpOnly and third-party cookies cannot be removed from JavaScript. */ }
}
